import { render, staticRenderFns } from "./CbxIncomeType.vue?vue&type=template&id=2458bcc2&"
import script from "./CbxIncomeType.vue?vue&type=script&lang=ts&"
export * from "./CbxIncomeType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports